import { render, staticRenderFns } from "./PaymentFooter.vue?vue&type=template&id=4108c3da&scoped=true"
import script from "./PaymentFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentFooter.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4108c3da",
  null
  
)

export default component.exports